import { Button } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import FreeTrialModal from 'components/providers/FreeTrialModal'

interface Props {
    providerId: number
}

const FreeTrialButton = ({ providerId }: Props) => {
    return (
        <Button onClick={() => NiceModal.show(FreeTrialModal, { providerId })} name="text">
            Start a free trial
        </Button>
    )
}

export default FreeTrialButton
